"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _properties = require("../utils/properties");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const iconAllowedProps = ['id', 'width', 'height', 'fill', 'viewBox', 'style', 'class', 'className', 'theme', 'size', ..._properties.elementEvents];
const withIcon = name => WrappedComponent => {
  var _Icon;
  return _Icon = class Icon extends _react.PureComponent {
    render() {
      const props = (0, _properties.getNativeProps)(this.props, iconAllowedProps);
      const dataProps = (0, _properties.getDataAttrsProps)(this.props);
      return _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, props, dataProps));
    }
  }, _Icon.displayName = name, _Icon.defaultProps = {
    fill: '#3b73b3'
  }, _Icon;
};
var _default = exports.default = withIcon;